// makeData.js

// Example data for the table
export const data = [
    { id: 1, firstName: 'John', lastName: 'Doe', company: 'ABC Corp', city: 'New York', country: 'USA' },
    { id: 2, firstName: 'Jane', lastName: 'Smith', company: 'XYZ Inc', city: 'London', country: 'UK' },
     
  ];
  